import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { resolvePageTitle } from '../../config/pageTitles';

const APP_BRAND = 'ServeIQ Admin';

const DynamicTitle = () => {
	const location = useLocation();
	const { profileData } = useSelector((state) => state.auth);

	useEffect(() => {
		const pathname = location.pathname;
		const pageTitle = resolvePageTitle(pathname);
		const isPublicAuth =
			pathname.includes('/user/login') || pathname.includes('/auto-login');

		const suffix = isPublicAuth ? APP_BRAND : profileData?.compName || APP_BRAND;

		if (pageTitle) {
			document.title = `${pageTitle} · ${suffix}`;
		} else {
			document.title = suffix;
		}
	}, [location.pathname, profileData?.compName]);

	return null;
};

export default DynamicTitle;
